<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="contact-list" v-for="(contact, index) in contacts" :key="index">
          <LocationFormContactItem
            :contact="contact"
            :index="index"
            @remove-contact="removeContact"
          />
        </div>
      </v-col>
      <v-btn class="add-new-contact-btn ml-4 px-5" outlined v-on:click="addContact()">
        <v-icon color="kazan" left>add</v-icon>
        {{$t('buttons.add')}}
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import LocationFormContactItem from '@/components/locations/LocationFormContactItem.vue'

export default {
  name: 'LocationFormContacts',
  components: {
    LocationFormContactItem
  },
  props: ['value'],
  data () {
    return {
      contacts: [...this.value]
    }
  },
  methods: {
    addContact: function () {
      let newContact = {
        name: '',
        surname: '',
        email: '',
        phone: ''
      }
      this.contacts.push(newContact)
    },
    removeContact: function (index) {
      this.contacts.splice(index, 1)
    }
  },
  watch: {
    contacts: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
